<template>
  <b-container fluid>
    <b-row>
      <b-col id="shipping-form" v-bind:class="selectedCourier ? 'courier-selected' : ''" v-if="selectedCourier">
        <h4 v-translate>Info Courier Panel</h4>
        <br>
        <p>
          <span v-translate="{data: selectedCourier.name}">Name: <strong>%{data}</strong></span>
          <b-badge variant="danger" v-show="selectedCourier.courier_available.tracking[0].shipping_id !== null" v-translate>Busy</b-badge>
        </p>
        <p>
          <span v-translate="{data: selectedCourier.email}">Email: <a href="mailto:%{data}">%{data}</a></span>
        </p>
        <p>
          <span v-translate="{data: selectedCourier.phone}">Phone: <strong>%{data}</strong></span>
          <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="'tel:' + selectedCourier.phone" v-translate>Call</a>
          <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="selectedCourier.phone" :href="$options.filters.whatsappize(selectedCourier.phone)">WhatsApp</a>
        </p>
        <div v-for="(shipping, index) in selectedCourier.courier_available.tracking" :key="index">
          <h4>
            <span v-translate="{index: index + 1}">Current Status %{index}:</span>
            <b-badge variant="danger" v-if="shipping.shipping_id" @click.prevent="getShipping(shipping.shipping_id)" v-translate="{data: $options.filters.uuid(shipping.shipping_id)}">Busy on #%{data}</b-badge>
            <b-badge variant="success" v-if="!shipping.shipping_id" v-translate>Free</b-badge>
          </h4>
        </div>
        <div v-if="selectedCourier.courier_available.tracking[0].shipping_id === null">
          <h4 v-translate>Assign Shipping</h4>
          <div class="input-group">
            <autocomplete ref="suggestions" v-model="searchQuery" :options="acOptions" :onItemSelected="onSearchItemSelected" :onInputChange="onInputChange">
              <div slot="item" slot-scope="props" class="single-item">
                <template v-if="props.item.Icon && props.item.Icon.URL">
                  <div class="image-wrap" :style="{'backgroundImage': 'url('+ props.item.Icon.URL + ')' }"></div>
                </template>
                <p>
                  <span v-translate="{data: props.item.id}">ID: %{data}</span><br>
                  <span v-translate="{data: props.item.address_from.formatted_address}">From: %{data}</span><br>
                  <span v-translate="{data: props.item.address_to.formatted_address}">To: %{data}</span>
                </p>
                <span class="name" v-if="props.item.main_text"><font-awesome-icon class="text-secondary " icon="map-marker-alt" size="sm" /> {{props.item.main_text + ', ' + props.item.secondary_text }}</span>
                <span v-if="props.item.reference"><font-awesome-icon class="text-secondary " icon="bookmark" size="sm" /> <strong>{{props.item.reference}}</strong><br>{{props.item.place.formatted_address}}</span>
              </div>
            </autocomplete>
          </div>
          <br>
        </div>
        <admin-shipping ref="theShipping" v-show="selectedSearchItem" :one-column="true" @shippingupdated="reloadShipping"></admin-shipping>
      </b-col>
      <b-col class="d-none d-md-block" id="shipping-map" v-bind:class="selectedCourier ? 'courier-selected' : ''">
        <leaflet-map ref="fullMap" :geolocate="true" @courier-selected="courierSelected" style="height: 100%" />
      </b-col>
    </b-row>
    <b-card id="layers-card">
      <b-form-group :label="$gettext('Layers:')">
        <b-form-checkbox-group v-model="selected" :options="[{value: 'couriers', text: $gettext('Couriers')}, {value: 'shippings', text: $gettext('Shippings')}]">
        </b-form-checkbox-group>
      </b-form-group>
    </b-card>
    <div id="filters-cards" v-show="this.selected.length > 0">
      <b-card id="shipping-filters-card" v-if="this.selected.indexOf('couriers') !== -1">
        <b-form-group :label="$gettext('Courier Statuses:')">
          <b-form-checkbox-group v-model="courierStatuses" :options="[{value: 'FREE', text: $gettext('FREE')}, {value: 'BUSY', text: $gettext('BUSY')}]">
          </b-form-checkbox-group>
        </b-form-group>
      </b-card>
      <b-card id="shipping-filters-card" v-show="this.selected.indexOf('shippings') !== -1">
        <b-form-group :label="$gettext('Shipping Statuses:')">
          <b-form-checkbox-group v-model="shippingStatuses" :options="['WAITING', 'READY', 'CONFIRMED', 'INTRANSIT', 'INCIDENCE']">
          </b-form-checkbox-group>
        </b-form-group>
      </b-card>
    </div>
  </b-container>
</template>
<script>
import LeafletMap from '@/components/LeafletMap'
import Cleave from 'vue-cleave'
import Autocomplete from '@/components/autocompletes/Autocomplete'
import AdminShipping from '@/components/AdminShipping'

export default {
  name: 'MapPage',
  title() {
    return this.$gettext('New Shipping')
  },
  components: {
    LeafletMap,
    Cleave,
    Autocomplete,
    AdminShipping
  },
  data() {
    return {
      fetchingShippings: false,
      fetchingCouriers: false,
      shippings: [],
      shippingStatuses: [],
      couriers: [],
      courierStatuses: [],
      vehicleTypesTranslations: [
        this.$gettext('MOTORCYCLE'),
        this.$gettext('CAR'),
        this.$gettext('VAN'),
        this.$gettext('TRUCK')
      ],
      params: {},
      intervalCouriers: null,
      intervalShippings: null,
      selectedCourier: null,
      searchQuery: '',
      selectedSearchItem: null,
      acOptions: {
        debounce: 500,
        placeholder: 'Shipping ID',
        inputClass: 'form-control'
      },
      minCharacter: 4,
      selected: [],
      markers: [],
      mobileApps: [],
      appsInUse: ''
    }
  },
  watch: {
    selected: function (val, oldVal) {
      clearInterval(this.intervalCouriers)
      this.fetchCouriers()
      this.intervalCouriers = setInterval(function () {
        this.fetchCouriers()
      }.bind(this), 30000)
      clearInterval(this.intervalShippings)
      this.fetchShippings()
      this.intervalShippings = setInterval(function () {
        this.fetchShippings()
      }.bind(this), 30000)
    },
    courierStatuses(val) {
      if (val.length > 0 && this.fetchingCouriers) {
        clearInterval(this.intervalCouriers)
        this.fetchCouriers()
        this.intervalCouriers = setInterval(function () {
          this.fetchCouriers()
        }.bind(this), 30000)
      } else {
        this.fetchCouriers()
      }
    },
    shippingStatuses(val) {
      if (val.length > 0 && this.fetchingShippings) {
        clearInterval(this.intervalShippings)
        this.fetchShippings()
        this.intervalShippings = setInterval(function () {
          this.fetchShippings()
        }.bind(this), 30000)
      } else {
        this.fetchShippings()
      }
    }
  },
  created() {
    this.fetchVehicleTypes()
    this.fetchMobileApps()
  },
  mounted() {
    this.courierStatuses = ['FREE', 'BUSY']
    this.shippingStatuses = ['WAITING', 'READY']
    this.selected = ['couriers']
  },
  beforeDestroy() {
    clearInterval(this.intervalCouriers)
    clearInterval(this.intervalShippings)
  },
  methods: {
    getShipping(id) {
      let params = {
        includes: [
          'status_history',
          'user',
          'company',
          'courier.courier_available.tracking',
          'budget.quote',
          'tags',
          'threads.messages.sender',
          'previousShipping',
          'followingShippings',
          'items'
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + id, {params: params})
        .then(response => {
          this.selectedSearchItem = response.body
          console.log(this.$refs)
          this.$refs.theShipping.shipping = response.body
          this.$refs.theShipping.courier = this.selectedCourier
        })
    },
    reloadShipping(shipping) {
      if (shipping.courier_id) {
        this.courierSelected(shipping.courier_id)
      }
      this.getShipping(shipping.id)
    },
    assignShipping(id) {
      console.log(id)
      console.log(this.selectedCourier)
      let params = {
        shipping_id: id,
        user_id: this.selectedCourier.id,
        status: 'CONFIRMED'
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
        .then(response => {
          this.courierSelected(this.selectedCourier.id)
        })
    },
    courierSelected(courierId) {
      console.log(courierId)
      if (courierId) {
        let params = {
          params: {
            includes: [
              'courier_available.tracking'
            ]
          }
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'users/' + courierId, params)
          .then(response => {
            this.selectedCourier = response.body
            this.selectedSearchItem = null
            this.$refs.theShipping.resetData()
            console.log(response.body)
          })
      } else {
        this.selectedCourier = null
        this.selectedSearchItem = null
        if (this.$refs.theShipping) {
          this.$refs.theShipping.shipping = {}
        }
      }
    },
    fetchMobileApps() {
      this.$http.get(this.$appConfig.api.baseUrl + 'mobile-apps')
        .then(response => {
          this.mobileApps = response.body.data
        })
    },
    fetchCouriers(params) {
      this.fetchingCouriers = true
      let filters = {
        sort: [
          {
            key: 'updated_at',
            direction: 'desc'
          }
        ],
        includes: [
          'user.mobile_apps',
          'user.courier_available.tracking'
        ]
      }
      filters.filter_groups = [{
        'filters': [
          ['active', 'eq', 1]
        ]
      }]
      if (!this.$cookies.get('bypassCountry')) {
        filters.filter_groups.push(
          {
            filters: [
              ['user.country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      if (this.courierStatuses.length > 0 && this.selected.indexOf('couriers') !== -1) {
        this.$http.get(this.$appConfig.api.baseUrl + 'couriers-available', { params: filters })
          .then(response => {
            let couriers = []
            if (this.courierStatuses.length > 0 && this.selected.indexOf('couriers') !== -1) {
              let icon = ''
              for (let i = 0; i < response.body.data.length; i++) {
                if (response.body.data[i].user.courier_available.tracking[0]) {
                  let isFree = response.body.data[i].user.courier_available.tracking[0].shipping_id === null || response.body.data[i].user.courier_available.tracking[0].shipping_id === '' ? 'blue' : 'gray'
                  let isCompanyCourier = response.body.data[i].user.company_id ? '-fleet' : ''
                  if ((this.courierStatuses.indexOf('FREE') !== -1 && isFree === 'blue') || (this.courierStatuses.indexOf('BUSY') !== -1 && isFree === 'gray')) {
                    icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-' + this.vehicleTypes.find(x => x.id === response.body.data[i].vehicle_type_id).name.toLowerCase() + '-' + isFree + isCompanyCourier + '.svg'

                    this.appsInUse = ''
                    response.body.data[i].user.mobile_apps.forEach(app => {
                      this.appsInUse += this.mobileApps.find(x => x.id === app.mobile_app_id).name + ' (' + app.version + '), '
                    })

                    let infoWindowHtml = ''
                    couriers.push({
                      id: response.body.data[i].user_id,
                      lat: response.body.data[i].user.courier_available.tracking[0].lat,
                      lng: response.body.data[i].user.courier_available.tracking[0].lng,
                      icon: icon,
                      x: 25,
                      y: 25,
                      infoText: {id: response.body.data[i].user_id, type: 'courier', html: infoWindowHtml, user: response.body.data[i].user, withPanel: true},
                      popup: true
                    })
                  }
                }
              }
            }
            if (JSON.stringify(couriers) !== JSON.stringify(this.couriers)) {
              this.couriers = couriers
              this.markers = this.arrayUnique(this.couriers.concat(this.shippings))
              this.$refs.fullMap.addMarkers(this.markers)
            }
            this.fetchingCouriers = false
          })
      } else {
        this.fetchingCouriers = false
        this.couriers = []
        this.markers = this.arrayUnique(this.couriers.concat(this.shippings))
        this.$refs.fullMap.addMarkers(this.markers)
      }
    },
    fetchShippings() {
      this.fetchingShippings = true
      let filters = {
        sort: [
          {
            key: 'updated_at',
            direction: 'desc'
          }
        ]
      }
      filters.filter_groups = [{
        'filters': [{
          'key': 'status',
          'value': this.shippingStatuses,
          'operator': 'in'
        },
        {
          'key': 'updated_at',
          'value': [this.moment().subtract(7, 'days').startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'), this.moment().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')],
          'operator': 'bt'
        }]
      },
      {
        'or': true,
        'filters': [{
          'key': 'scheduled_date',
          'value': null,
          'operator': 'eq'
        },
        {
          'key': 'scheduled_date',
          'value': this.moment().utc().format('YYYY-MM-DD HH:mm:ss'),
          'operator': 'lte'
        }]
      }]

      if (!this.$cookies.get('bypassCountry')) {
        filters.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.shippingStatuses.length > 0 && this.selected.indexOf('shippings') !== -1) {
        this.$http.get(this.$appConfig.api.baseUrl + 'shippings?includes[]=status_history', { params: filters })
          .then(response => {
            let shippings = []
            if (this.shippingStatuses.length > 0 && this.selected.indexOf('shippings') !== -1) {
              let lat
              let lng
              let icon = ''
              for (let i = 0; i < response.body.data.length; i++) {
                switch (response.body.data[i].status) {
                  case 'WAITING':
                    icon = 'https://avatars.discourse.org/v2/letter/W/996600/24.png'
                    break
                  case 'READY':
                    icon = 'https://avatars.discourse.org/v2/letter/R/999999/24.png'
                    break
                  case 'CONFIRMED':
                    icon = 'https://avatars.discourse.org/v2/letter/C/009900/24.png'
                    break
                  case 'INTRANSIT':
                    icon = 'https://avatars.discourse.org/v2/letter/I/009900/24.png'
                    break
                  case 'INCIDENCE':
                    icon = 'https://avatars.discourse.org/v2/letter/I/FFcc00/24.png'
                    break
                  case 'DELIVERED':
                    icon = 'https://avatars.discourse.org/v2/letter/D/000000/24.png'
                    break
                  default:
                    icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-van-gray.svg'
                }

                if (response.body.data[i].status === 'INTRANSIT') {
                  if (response.body.data[i].current_tracking) {
                    lat = response.body.data[i].current_tracking.lat
                    lng = response.body.data[i].current_tracking.lng
                  } else {
                    lat = response.body.data[i].address_from.lat
                    lng = response.body.data[i].address_from.lng
                    icon = 'https://avatars.discourse.org/v2/letter/I/990000/24.png'
                  }
                } else if (response.body.data[i].status !== 'DELIVERED') {
                  lat = response.body.data[i].address_from.lat
                  lng = response.body.data[i].address_from.lng
                } else {
                  lat = response.body.data[i].address_to.lat
                  lng = response.body.data[i].address_to.lng
                }
                let infoWindowHtml = '<p><strong><a href="/edit/shippings/' + response.body.data[i].id + '" target="_blank">' + this.$gettext('Edit Shipping') + '</a></strong></p>'
                infoWindowHtml += response.body.data[i].status_history.length > 0 ? this.$gettextInterpolate(this.$gettext('<p>Current status: <strong>%{data}</strong></p>'), {data: response.body.data[i].status_history[0].status}) : ''
                infoWindowHtml += response.body.data[i].status_history.length > 0 && response.body.data[i].status_history[0].details ? this.$gettextInterpolate(this.$gettext('<p>Status details: <strong>%{data}</strong></p>'), {data: response.body.data[i].status_history[0].details.reason || ''}) : ''
                infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>From: <strong>%{data}</strong></p>'), {data: response.body.data[i].address_from.formatted_address || ''})
                infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>To: <strong>%{data}</strong></p>'), {data: response.body.data[i].address_to.formatted_address || ''})
                infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Last updated: <strong>%{data}</strong></p>'), {data: this.moment.utc(response.body.data[i].updated_at).tz(this.$tz).format('YYYY-MM-DD HH:mm:ss')})
                infoWindowHtml += response.body.data[i].courier ? this.$gettextInterpolate(this.$gettext('<p>Courier: <strong>%{data}</strong></p>'), {data: response.body.data[i].courier.name}) : ''
                infoWindowHtml += response.body.data[i].courier ? this.$gettextInterpolate(this.$gettext('<p>Phone: <a href="tel:%{data}"><strong>%{data}</strong></a></p>'), {data: response.body.data[i].courier.phone || ''}) : ''

                shippings.push({
                  id: 100000 + i,
                  lat: lat,
                  lng: lng,
                  icon: icon,
                  x: 12,
                  y: 12,
                  infoText: {id: response.body.data[i].id, type: 'shipping', html: infoWindowHtml, ids: [response.body.data[i].id]},
                  popup: true
                })
              }
            }

            if (JSON.stringify(shippings) !== JSON.stringify(this.shippings)) {
              this.shippings = shippings
              this.markers = this.arrayUnique(this.couriers.concat(this.shippings))
              this.$refs.fullMap.addMarkers(this.markers)
            }
            this.fetchingShippings = false
          })
      } else {
        this.fetchingShippings = false
        this.shippings = []
        this.markers = this.arrayUnique(this.couriers.concat(this.shippings))
        this.$refs.fullMap.addMarkers(this.markers)
      }
    },
    onInputChange(query) {
      let url = ''
      if (query.trim().length >= this.minCharacter) {
        console.log(query)
        let params = {
          params: {
            sort: [{
              key: 'created_at',
              direction: 'desc'
            }],
            filter_groups: [{
              filters: [
                ['id', 'ct', query.trim()],
                ['status', 'in', ['WAITING', 'INCIDENCE']]
              ]
            }]
          }
        }
        url = this.$appConfig.api.baseUrl + 'shippings?includes[]=status_history&includes[]=user'
        return new Promise(resolve => {
          this.$http.get(url, params).then(response => {
            const items = []
            response.body.data.forEach((item) => {
              if (item.address_from) {
                items.push(item)
              } else if (item.Topics && item.Topics.length > 0) {
                item.Topics.forEach(topic => {
                  items.push(topic)
                })
              }
            })
            resolve(items)
          })
        })
      }
    },
    onSearchItemSelected(item) {
      this.selectedSearchItem = item
      this.$refs.theShipping.shipping = item
      this.$refs.theShipping.courier = this.selectedCourier
    },
    focusPhoneInput() {
      this.$refs.phoneValidation.$refs.phoneInput.$el.focus()
    },
    closeModalPhone() {
      this.$refs.modalEnterPhone.hide()
    },
    successModalPhone() {
      this.fetchProfile()
      this.$refs.modalEnterPhone.hide()
    },
    focusAddressInput() {
      this.$refs.addAddress.$refs.addressAutocomplete.$el.children[0].focus()
    },
    closeModalAddress() {
      this.$refs.modalEnterAddress.hide()
    },
    successModalAddress() {
      console.log('YASSS')
      setTimeout(function () {
        this.fetchProfile()
        this.$refs.modalEnterAddress.hide()
      }.bind(this), 500)
    },
    countdown(value, limit) {
      this.limits[value] = this.shipping[value] ? limit - this.shipping[value].length : null
      this.invalid[value] = this.shipping[value] ? this.shipping[value].length <= limit : null
    }
  }
}

</script>
<style lang="scss">
.shipping-trigger {
  position: relative;

  img {
    width: 100%;
    height: auto;
  }

  .modal-trigger {
    position: absolute;
    width: 100%;
    height: 100%;

    .btn {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &.from {
    .modal-trigger {
      background: rgba(40, 208, 182, .3);
    }

    .shipping-data {
      background: rgba(40, 208, 182, .3);
      padding: 1rem;
      cursor: pointer;
    }
  }

  &.to {
    .modal-trigger {
      background: rgba(79, 160, 255, .3);
    }

    .shipping-data {
      background: rgba(79, 160, 255, .3);
      padding: 1rem;
      cursor: pointer;
    }
  }
}

.courier_row {
  min-height: 2.5rem;
  label {
    font-size: 1rem
  }
  .courier_type_1 {
    background: url(../assets/img/ic_field_moto_blue.svg) no-repeat 10px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_moto_gray.svg);
      color: #999 !important;
    }
  }

  .courier_type_2 {
    background: url(../assets/img/ic_field_car_blue.svg) no-repeat 10px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_car_gray.svg);
      color: #999 !important;
    }
  }

  .courier_type_3 {
    background: url(../assets/img/ic_field_van_blue.svg) no-repeat 15px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_van_gray.svg);
      color: #999 !important;
    }
  }

  .courier_type_4 {
    background: url(../assets/img/ic_field_camioneta_blue.svg) no-repeat 10px 50%;
    padding: 20px 0 20px 70px;
    &.text-muted {
      background-image: url(../assets/img/ic_field_camioneta_gray.svg);
      color: #999 !important;
    }
  }
}

.modal-select-budget {
  .card {
    .courier_type_1 {
      background: url(../assets/img/ic_field_moto_gray.svg) no-repeat 0 50%;
      padding-left: 60px;
    }

    .courier_type_2 {
      background: url(../assets/img/ic_field_car_gray.svg) no-repeat 0 50%;
      padding-left: 60px;
    }

    .courier_type_3 {
      background: url(../assets/img/ic_field_camioneta_gray.svg) no-repeat 0 50%;
      padding-left: 60px;
    }

    &:hover {
      .courier_type_1 {
        background: url(../assets/img/ic_field_moto_blue.svg) no-repeat 0 50%;
        padding-left: 60px;
      }

      .courier_type_2 {
        background: url(../assets/img/ic_field_car_blue.svg) no-repeat 0 50%;
        padding-left: 60px;
      }

      .courier_type_3 {
        background: url(../assets/img/ic_field_camioneta_blue.svg) no-repeat 0 50%;
        padding-left: 60px;
      }
    }
  }
}

.save-from .switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 20px;
}

.save-from input {
  opacity: 0;
  width: 0;
  height: 0;
}
.save-from {
  padding-left: 0;
  margin-bottom: 1.5rem;
  label {
    span {
      vertical-align: bottom;
    }
    &:before, &:after {
      display: none;
    }
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .15s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .15s;
}

input:checked + label .slider {
  background-color: #2196F3;
}

input:focus + label .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + label .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#filters-cards {
  position: fixed;
  bottom: 0;
  right: 215px;
  width: 450px;
  z-index: 1000;
  text-align: right
}
#layers-card {
  position: fixed;
  bottom: 0;
  right: 10px;
  z-index: 1000;
  width: 200px
}
#shipping-filters-card {
  width: 200px;
  display: inline-block;
  margin-right: 10px;
  text-align: left;
  vertical-align: bottom;
}
</style>
